import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-treelist-date-cell',
  template: `<span>{{ value | date:format }}</span>`,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TreelistDateCellComponent {
  @Input() value: string | Date;
  @Input() format: string = 'MM/dd/yyyy';
}
